import './_table.scss';

const toggleTableRows = (section) => {
    section.classList.toggle('table-section--open');
    
    const tableRows = section.querySelectorAll('tr');
    const tableButton = section.querySelector('.button');
    const tableOpen = section.classList.contains('table-section--open');

    tableRows.forEach((row, index) => {
        row.style.display = !tableOpen && index >= 5 ? 'none' : 'flex';
    });

    tableButton.innerHTML = tableOpen ? 'Show Fewer Rows —' : 'Show More Rows +';
};

document.addEventListener('DOMContentLoaded', function() {
    const tableSections = document.querySelectorAll('.table-section');

    tableSections.forEach((section) => {
        const tableButton = section.querySelector('.button');
        
        if (tableButton) {
            tableButton.addEventListener('click', () => toggleTableRows(section));
        }
    });
});